import { render } from "./LockSvg.vue?vue&type=template&id=1fd4614d&bindings={}"
import script from "./LockSvg.vue?vue&type=script&lang=ts"
export * from "./LockSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script